import vm from "vm";

// The following objects will be accessible inside isolatedEval
const whitelistedObjects = {
  Math,
  console,
  // eslint-disable-next-line id-denylist
  Number,
  // eslint-disable-next-line id-denylist
  String,
  // eslint-disable-next-line id-denylist
  Boolean,
  isNaN,
  XMLHttpRequest,
  Date,
  JSON,
  parseInt,
};

const createSandboxCode = (code: string, context) => {
  const contextKeys = Object.keys(context);
  const escapedContextKeys = JSON.stringify(contextKeys).replace(/'/g, "\\'");

  const objectsToShadow = ["window", "document", "location", "history", "localStorage", "sessionStorage"];
  const removeWindowObjects = ["document", "localStorage", "sessionStorage", "history"];

  return `
        (function(window) {
            const removeData = obj => {
                Object.getOwnPropertyNames(Object.getPrototypeOf(obj))
                    .filter(key => key !== 'location')
                    .forEach(key => delete obj[key]); 
                    
                Object.setPrototypeOf(obj, null);
            }
            
            ${removeWindowObjects.map((value) => "removeData(window." + value + ");").join("\n")}
            
            const allowedKeysSet = new Set(JSON.parse('${escapedContextKeys}'));
                  
            Object.getOwnPropertyNames(window)
                  .filter(key => !allowedKeysSet.has(key)) 
                  .filter(key => key !== 'location')
                  .forEach(key => delete window[key]); 
        })(this);

        ${objectsToShadow.map((value) => "const " + value + " = {};").join("\n")}
        
        ${code}
    `;
};

const doIsolatedEval = (code: string, context = {}) => vm.runInNewContext(createSandboxCode(code, context), context);

export const isolatedEval = (code: string, context = {}) =>
  doIsolatedEval(code, {
    eval: doIsolatedEval,
    ...whitelistedObjects,
    ...context,
  });
